import React, { useEffect, useState } from "react";
import AddLeadDetails from "../../Stepper/addNewLead/AddLeadDetails";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ApiPost } from "../../../../helpers/API/ApiData";
import { getUserInfo } from "../../../../utils/user.util";
import ValidateForm from "../LeadsValidations";

export default function LeadsValidForm(props) {
  const { 
    isShowLeadModel, 
    handleAddLeadModalClose, 
    locationData, 
    setIsLeadCreatedZoom,
    handleGetDashboardCount 
  } = props;
  const [leadDetails, setLeadDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const usersData = getUserInfo();

  useEffect(() => {
    if (locationData) {
      setLeadDetails({
        ...leadDetails,
        adresse: locationData.adresse,
        ort: locationData.ort,
        postleitzahl: locationData.postleitzahl,
        nr: locationData.nr,
        locationCoordinates: locationData.locationCoordinates,
      });
    }
  }, [locationData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeadDetails({ ...leadDetails, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleAddLead = () => {
    const isValid = ValidateForm(leadDetails, setErrors);
    if (isValid) {
      setLoading(true);
      const locationCoordinates = {
        type: "Point",
        coordinates: [leadDetails?.locationCoordinates?.lng, leadDetails?.locationCoordinates?.lat],
      };
      let body = {
        name: leadDetails?.vorname ? leadDetails?.vorname : "",
        nachname: leadDetails?.nachname ? leadDetails?.nachname : "",
        comment: leadDetails?.comment ? leadDetails?.comment : "",
        firma: leadDetails?.firma ? leadDetails?.firma : "",
        strabe: leadDetails?.adresse ? leadDetails?.adresse : "",
        pLZ: leadDetails?.postleitzahl ? leadDetails?.postleitzahl : "",
        location: leadDetails?.ort ? leadDetails?.ort : "",
        telephon: leadDetails?.kontakt ? leadDetails?.kontakt : "",
        email: leadDetails?.eMail ? leadDetails?.eMail : "",
        notizen: leadDetails?.importantInfo ? leadDetails?.importantInfo : "",
        contractions: leadDetails?.anrede ? leadDetails?.anrede : "",
        ...(leadDetails?.website && {
          website: leadDetails?.website ? leadDetails?.website : "",
        }),
        ...(leadDetails?.numberOfEmployees && {
          numberOfEmployees: leadDetails?.numberOfEmployees
            ? leadDetails?.numberOfEmployees
            : "",
        }),
        ...(leadDetails?.decisionMakerReached && {
          decisionMakerReached: leadDetails?.decisionMakerReached
            ? leadDetails?.decisionMakerReached
            : "",
        }),
        ...(leadDetails?.openingHours && {
          openingHours: leadDetails?.openingHours
            ? leadDetails?.openingHours
            : "",
        }),
        benutzername: "admin",
        benutzerId: usersData?._id,
        locationCoordinates: JSON.stringify(locationCoordinates),
      };

      ApiPost(`straper/vattenfall`, body)
        .then((res) => {
          toast.success("Lead erfolgreich hinzugefügt");
          setLoading(false);
          // Call the refresh function before closing the modal
          if (typeof handleGetDashboardCount === 'function') {
            handleGetDashboardCount();
          }
          // Close the form
          handleAddLeadModalClose();
          setLeadDetails({});
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setLoading(false);
          setLeadDetails({});
          handleAddLeadModalClose();
        });
    }
  };
  return (
    <>
      <Modal
        show={isShowLeadModel}
        onHide={handleAddLeadModalClose}
        className="d-flex justify-content-center align-items-center"
      >
        <AddLeadDetails
          inputValue={leadDetails}
          setInputValue={setLeadDetails}
          handleOnClose={handleAddLeadModalClose}
          formType={"add"}
          handleChange={handleChange}
          handleAddNews={handleAddLead}
          loading={loading}
          errors={errors}
          setError={setErrors}
        />
      </Modal>
    </>
  );
}
